export default __webpack_public_path__ + "static/media/g_logo.3ecb0cbc.jpg";